import { put, select, race, take, takeLatest } from "redux-saga/effects";
import {
  associateEquipRule,
  ASSOCIATE_RULE_EQUIP_REQUEST_SUCCESS,
  ASSOCIATE_RULE_EQUIP_REQUEST_FAIL,
} from "./associate";
import { addedActionEvent } from "../../../utils/eventTracking";

const INITIAL_STATE = {
  isCreating: false,
};

const CREATE_ACTION = "bonfire/issues/CREATE_ACTION";
export const CREATE_ACTION_REQUEST = "bonfire/issues/CREATE_ACTION_REQUEST";
export const CREATE_ACTION_REQUEST_SUCCESS =
  "bonfire/issues/CREATE_ACTION_REQUEST_SUCCESS";
export const CREATE_ACTION_REQUEST_FAILURE =
  "bonfire/issues/CREATE_ACTION_REQUEST_FAIL";

export const createAction = (issue) => ({ type: CREATE_ACTION, issue });
export const createActionRequestChain = (user, issue) => ({
  types: [
    CREATE_ACTION_REQUEST,
    CREATE_ACTION_REQUEST_SUCCESS,
    CREATE_ACTION_REQUEST_FAILURE,
  ],
  promise: (client) =>
    client.post("/issue", {
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
      data: {
        ...issue,
      },
    }),
});

export function reducer(state = INITIAL_STATE, action = {}) {
  switch (action.type) {
    case CREATE_ACTION_REQUEST:
      return {
        ...state,
        isCreating: true,
      };
    case CREATE_ACTION_REQUEST_SUCCESS:
      return {
        ...state,
        isCreating: false,
      };
    case CREATE_ACTION_REQUEST_FAILURE:
      return {
        ...state,
        isCreating: false,
      };
    default:
      return state;
  }
}

// TODO: This should probably live in the `associate.js` sagas
export function* handleCreateAndAssociate(action) {
  try {
    const { projects } = yield select((state) => state.userSites);
    const site = yield select((state) => state.betaSelections.activeSite);
    const { user } = yield select((state) => state.auth);
    const projectKey = projects[site.projectId].jira_key;
    const { target } = action.issue;

    const issue = {
      ...action.issue,
      projectKey,
      components: [{ name: site.id.split("~")[1] }],
      target: "",
      issueType: "Spark",
      transition: action.issue.status,
      labels: ["insite-created", "user-created"],
    };

    yield put(createActionRequestChain(user, issue));

    const { success, failure } = yield race({
      success: take(CREATE_ACTION_REQUEST_SUCCESS),
      failure: take(CREATE_ACTION_REQUEST_FAILURE),
    });

    if (failure)
      throw new Error(`Error creating issue: ${failure.error.message}`);

    if (success) {
      // Associate equip/rules to newly created issue
      const { issueKey } = success.result;
      yield put(associateEquipRule({ equipRuleIds: target, issueKey }));
      const { associateSuccess, associateFailure } = yield race({
        associateSuccess: take(ASSOCIATE_RULE_EQUIP_REQUEST_SUCCESS),
        associateFailure: take(ASSOCIATE_RULE_EQUIP_REQUEST_FAIL),
      });
      const associateResult = associateSuccess ? associateSuccess.result : null;
      const associateError = associateFailure ? "Failed to associate" : null;
      addedActionEvent(
        success.result.issueKey,
        action.issue,
        site,
        associateResult,
        associateError
      );
    }
  } catch (err) {
    yield put({ type: CREATE_ACTION_REQUEST_FAILURE, error: err });
  }
}

export function* watchCreateAndAssociate() {
  yield takeLatest(CREATE_ACTION, handleCreateAndAssociate);
}
